<script>
export default {
  name: "reginData",
  props: {
    regionId: {
      type: Number
    }
  },
  data() {
    return {
      info: {
        equipment: 0,
        card: 0,
        shouyi: 0
      }
    };
  },
  watch: {
    regionId: {
      handler(v) {
        this.getData(v);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getData(regionId) {
      this.$api.partner.regionDetail({ regionId }).then(res => {
        if (res.code === 200) {
          this.info.equipment = res.data.deviceCount;
          this.info.card = res.data.cardCount;
          this.info.shouyi = res.data.ratioCount;
        }
      });
    }
  },
  render(createElement, context) {
    return createElement("div", [this.$scopedSlots.default(this.info)]);
  }
};
</script>
